enum DocusignStatus {
  NEW = 'new',
  READY = 'ready',
  DONE = 'done',
  VOIDED = 'voided',
  PROCESSING = 'processing'
}

enum ErpStatus {
  NEW = 'new',
  READY = 'ready',
  DONE = 'done',
  FAILURE = 'failed',
  PROCESSING = 'processing',
  NEED = 'need',
  VOIDED = 'voided'
}

enum FlowStatus {
  UNASSIGNED = 'unassigned',
  APPROVED = 'approved',
  PENDING = 'pending',
  DISPUTED = 'disputed',
  PAID = 'paid',
  CANCELLED = 'cancelled',
  NEW = 'new',
  UNDER_REVIEW = 'under_review'
}

enum ProcoreStatus {
  NEW = 'new',
  READY = 'ready',
  DONE = 'done',
  FAILURE = 'failed',
  PROCESSING = 'processing'
}

enum ERPs {
  NONE = 'none',
  QB = 'QuickBooks',
  QBD = 'QuickBooksDesktop',
  PROCORE = 'Procore',
  SAGE = 'Sage'
}

enum OrdersFetchDataMethod {
  Entire = 'entire',
  Pdf = 'pdf',
  LineItem = 'lineItem',
  Detail = 'detail'
}

export { DocusignStatus, ErpStatus, FlowStatus, ProcoreStatus, ERPs, OrdersFetchDataMethod };
